import {
  GetProductFilterResponse,
  ProductCategoryListResource,
  ProductCategoryListResourceCategories,
  ProductDetailResource,
  ProductListResource,
  ProductPageResource,
} from "@/api/generated-api";
import { ProductsListRequestType } from "@/api/catalog/types";
import ApiClient from "@/api/ampm-world";

export class ApiCatalog {
  static async getCategories(lang: string): Promise<ProductCategoryListResourceCategories[]> {
    const data = await ApiClient.get<ProductCategoryListResource>(`/${lang}/categories`);

    return data.categories;
  }

  static async getCategoriesPage(lang: string): Promise<ProductPageResource> {
    return ApiClient.get<ProductPageResource>(`/${lang}/page/category`);
  }

  static async getProducts(lang: string, params: ProductsListRequestType): Promise<ProductListResource> {
    return ApiClient.get<ProductListResource>(`/${lang}/products`, params);
  }

  static async getProductsFilters(lang: string, params: ProductsListRequestType): Promise<GetProductFilterResponse> {
    return ApiClient.get<GetProductFilterResponse>(`/${lang}/product/filter`, params);
  }

  static async getDetailProduct(lang: string, id: string): Promise<ProductDetailResource> {
    return ApiClient.get<ProductDetailResource>(`/${lang}/product/${id}`);
  }
}
